import React, { useEffect, useRef, useState } from "react";
import AccountsButton from "./AccountsButton";
import SideMenu from "../General/SideMenu";
import MasterList from "../Master/MasterListItem";
import PayRecBody from "./PayRecBody";
import { Ask_Question, Show_Message } from "../General/Messagedialogbox";
import { useDispatch, useSelector } from "react-redux";
import {
  payModeInputFlags,
  refresh_Acc,
  setAcc_HT,
  setAcc_Payment,
  setAcc_TabOrder,
  setAcc_VouchNo,
  setAcc_default,
  toISODate,
} from "../features/Accounts";
import Messagedialogbox from "../General/Messagedialogbox";
import { API_FETCH, API_POST, DecryptData } from "../General/Utility";
function Receipt() {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const _AccParem = useSelector((state) => state.Accounts.default);
  const _HTParem = useSelector((state) => state.Accounts.HT);
  const _TabParem = useSelector((state) => state.Accounts.TabOrder);
  const [strSearch, setstrSearch] = useState("");
  const recIdRef = useRef(0);
  recIdRef.current = Number(_AccParem.iPayRecId) || 0;

  useEffect(() => {
    Load_Receipt();
  }, []);

  // Redux Admin can be empty right after a page refresh, so fall back to the
  // encrypted values in localStorage (same approach as Payment.js).
  const sessionParams = async () => {
    const local = (await DecryptData(localStorage.jbctrlparams)) || {};
    return {
      Branch: Number(_AuthParems.Branch || local.Branch),
      DB: _AuthParems.DB || local.DB,
    };
  };

  const Load_Receipt = async (opts = {}) => {
    const session = await sessionParams();
    const keepForm = opts.keepForm === true && recIdRef.current > 0;
    const res = await API_FETCH(
      `Receipt/Load_Receipt/${session.Branch}/${session.DB}`,
      dispatch
    );
    if (res) {
      const arrBank = res.objEntBank || [];
      dispatch(
        setAcc_HT({
          arrNoFormat: res.objEntNoFormat || [],
          arrPayment: res.objEntReceipt || [],
          arrPayMode: res.objEntPayMode || [],
          arrBankAcc: arrBank,
          arrBankAccDetails: [],
          arrVenType: res.objEntVenType || [],
          arrValidateProperties: res.Transtab || [],
        })
      );
      const objNo = (res.objEntNoFormat || [])[0];
      if (!objNo) {
        Show_Message(
          dispatch,
          "Voucher number format is not configured for Receipt",
          "error"
        );
      }
      if (!keepForm) {
        dispatch(
          setAcc_VouchNo({
            iBranchId: session.Branch,
            iScrId: 42,
            iVenTypeId: 4,
            strTransNo: objNo ? objNo.strTransNo : "",
            strVouchNo: objNo ? objNo.strUserNo : "",
            iBankAccId: arrBank.length > 0 ? arrBank[0].bankAccId : 0,
          })
        );
      }
      TabOrderAssign(res.Transtab || []);
    }
  };
  const Search_Receipt = async (strtext) => {
    setstrSearch(strtext);
    const session = await sessionParams();
    const objSearch = {
      iBranchId: session.Branch,
      iScrId: "",
      iPartyId: "",
      strColName: "All",
      strSearch: strtext,
      strDBName: session.DB,
    };
    const res = await API_POST("Receipt/Search_Receipt/", objSearch, dispatch);
    if (res) dispatch(setAcc_Payment(res.objEntRecpt || []));
  };
  const ClearClick = () => {
    dispatch(refresh_Acc());
    Load_Receipt();
  };
  const Cancel_Receipt = async () => {
    const session = await sessionParams();
    // FIX: body was missing, so dispatch was passed in the body position
    const res = await API_POST(
      `Receipt/Cancel_Receipt/${_AccParem.iPayRecId}/${session.DB}`,
      {},
      dispatch
    );
    if (res) {
      ClearClick();
      Show_Message(dispatch, res.strMessage, "success");
    }
  };
  const Save_Receipt = async () => {
    const session = await sessionParams();
    const fmt = (_HTParem.arrNoFormat || [])[0] || {};
    const iPayMode = Number(_AccParem.iPayModeId);
    const objInsUpdRec = {
      // FIX: iScrId was not sent, so the server's duplicate voucher number
      // check ran with ScrId 0
      iScrId: 42,
      iRecId: _AccParem.iPayRecId,
      iBranchId: _AccParem.iBranchId,
      strRecNo: _AccParem.strVouchNo,
      dpRecDate: _AccParem.strVouchDate,
      strTransNo: _AccParem.strTransNo,
      strPrefix: fmt.strPrefix,
      iNumSeqNo: fmt.iNumSeqNo,
      strCompCode: fmt.strCompCode,
      strFinanFrom: fmt.strFinanFrom,
      iVenType: _AccParem.iVenTypeId,
      iVenId: _AccParem.iVenId,
      iPayModeId: iPayMode,
      dAmount: _AccParem.dAmount,
      // Cash: bank / cheque / account details from an earlier mode must not
      // be saved
      iBankAccId: iPayMode === 1 ? 0 : _AccParem.iBankAccId,
      strChequeNo: iPayMode === 2 ? _AccParem.strChequeNo : "",
      dpChequeDate:
        iPayMode === 2 ? _AccParem.strChequeDate : _AccParem.strVouchDate,
      strAccNo: iPayMode === 1 ? "" : _AccParem.strAccNo,
      strAccHolderName: iPayMode === 1 ? "" : _AccParem.strAccHolderName,
      strPrintName: _AccParem.strPrintName,
      strRemark: _AccParem.strRemark,
      iBNId: iPayMode === 1 ? 0 : _AccParem.iBankId,
      iVouchId: 0,
      iCallerScrId: 0,
      strBankName: iPayMode === 1 ? "" : _AccParem.strBankName,
      strFilter: "",
      strFilterColumn: "All",
      strSearch: "",
      strVenName: _AccParem.strVenName,
      strDBName: session.DB,
    };
    const res = await API_POST(
      "Receipt/InsUpd_Receipt/",
      objInsUpdRec,
      dispatch
    );
    if (res) {
      ClearClick();
      Show_Message(dispatch, res.strMessage, "success");
    }
  };
  const View_Receipt = async (RecId) => {
    const session = await sessionParams();
    const res = await API_FETCH(
      `Receipt/View_Receipt/${RecId}/${session.DB}`,
      dispatch
    );
    if (res) {
      let objVoucher = res.objEntRecp;
      const flags = payModeInputFlags(objVoucher.iPayModeId);
      dispatch(
        setAcc_default({
          iBranchId: _AccParem.iBranchId,
          iScrId: _AccParem.iScrId,
          iPayRecId: RecId,
          strTransNo: objVoucher.strTransNo,
          strVouchNo: objVoucher.strRecNo,
          // FIX: API sends dd-MM-yyyy, <input type="date"> needs yyyy-MM-dd
          strVouchDate: toISODate(objVoucher.dpRecDate),
          iVenTypeId: Number(objVoucher.iVenType),
          iVenId: Number(objVoucher.iVenId),
          strVenName: objVoucher.strVenName,
          iPayModeId: Number(objVoucher.iPayModeId),
          iBankAccId: Number(objVoucher.iBankAccId) || 0,
          strChequeNo: objVoucher.strChequeNo || "",
          strChequeDate:
            toISODate(objVoucher.dpChequeDate) ||
            toISODate(objVoucher.dpRecDate),
          strAccHolderName: objVoucher.strAccHolderName || "",
          strBankName: objVoucher.strBankName || "",
          iBankId: Number(objVoucher.iBNId) || 0,
          strAccNo: objVoucher.strAccNo || "",
          strPrintName: objVoucher.strPrintName || "",
          strRemark: objVoucher.strRemark || "",
          dAmount: Number(objVoucher.dAmount).toFixed(2),
          isCheque: flags.isCheque,
          isBanAcc: flags.isBanAcc,
          isCancelStatus: !!objVoucher.bCancelStatus,
          strSearch: "",
        })
      );
    }
  };
  const TabOrderAssign = (EntProperties) => {
    const arrTab = (EntProperties || []).filter(
      (Data) => Data.isTabStop === true
    );
    const ctrlMap = {
      txtEntNo: "TransNoTab",
      dpEntDate: "TranDate",
      txtVouchNo: "VoucherTab",
      dpVouchDate: "VouchDateTap",
      txtVenName: "VenNameTab",
      cbVenType: "VenTypeTab",
      cbPayMode: "PayModeTab",
      txtChequeNo: "CheckNoTab",
      dpChequeDate: "CheckDateTab",
      cbBankAcc: "BankAccountTab",
      txtAccHolderName: "AccHolTab",
      txtAccNo: "AccNoTab",
      txtBankName: "BankNameTab",
      txtAmt: "AmountTab",
      txtPrintName: "PrintNameTab",
      txtRemark: "Remarktab",
      lbVouchers: "PaymentListTab",
      cbFilter: "PaymentFIlterTab",
      txtSearch: "PaymentSearchTab",
      btnSave: "BtnSavtab",
      btnClear: "BtnCleartab",
      btnDelete: "BtnDeletetab",
      btnClose: "BtnClosetab",
      btnCancel: "BtnCancel",
      btnAdjust: "BtnAdjust",
    };
    // FIX: this used to dispatch once per control, each time rebuilding the
    // WHOLE tab-order object from the same stale copy, so every dispatch
    // overwrote the previous one and only the LAST control kept its tab
    // index. Build the object once, dispatch once.
    // (txtAccNo and btnDelete were also never matched before: they were
    // compared with "" instead of the real control names.)
    const objTab = { ..._TabParem };
    arrTab.forEach((p) => {
      const key = ctrlMap[p.strCtrlName];
      if (key) objTab[key] = p.iTabIndex;
    });
    dispatch(setAcc_TabOrder(objTab));
    const maxTab = arrTab.reduce(
      (mx, p) => Math.max(mx, Number(p.iTabIndex) || 0),
      0
    );
    sessionStorage.maxTab = maxTab;
  };
  const PropertiesValidation = () => {
    // A disabled control cannot be filled by the user, so it must not be
    // validated. isCheque / isBanAcc = true means that group is DISABLED.
    const isDisabledCtrl = (strCtrlName) => {
      switch (strCtrlName) {
        case "txtChequeNo":
        case "dpChequeDate":
          return _AccParem.isCheque === true;
        case "txtBankName":
        case "cbBankAcc":
        case "txtAccHolderName":
        case "txtAccNo":
          return _AccParem.isBanAcc === true;
        default:
          return false;
      }
    };

    const isEmpty = (val) =>
      val === undefined || val === null || String(val).trim() === "";

    const ValidateItem = (_HTParem.arrValidateProperties || []).filter(
      (Data) => Data.isValidate === true
    );

    for (let i = 0; i < ValidateItem.length; i++) {
      const strCtrl = ValidateItem[i].strCtrlName;
      if (isDisabledCtrl(strCtrl)) continue;

      let isInvalid = false;
      switch (strCtrl) {
        case "txtVouchNo":
          isInvalid = isEmpty(_AccParem.strVouchNo);
          break;
        case "cbVenType":
          isInvalid = !Number(_AccParem.iVenTypeId);
          break;
        case "txtVenName":
          isInvalid =
            Number(_AccParem.iVenTypeId) !== 6 && isEmpty(_AccParem.strVenName);
          break;
        case "cbBankAcc":
          isInvalid =
            Number(_AccParem.iPayModeId) !== 1 && !Number(_AccParem.iBankAccId);
          break;
        case "txtAccNo":
          isInvalid =
            Number(_AccParem.iPayModeId) !== 1 && isEmpty(_AccParem.strAccNo);
          break;
        case "txtAmt":
          isInvalid = !(Number(_AccParem.dAmount) > 0);
          break;
        case "txtPrintName":
          isInvalid = isEmpty(_AccParem.strPrintName);
          break;
        case "txtRemark":
          isInvalid = isEmpty(_AccParem.strRemark);
          break;
        case "txtChequeNo":
          isInvalid = isEmpty(_AccParem.strChequeNo);
          break;
        case "dpChequeDate":
          isInvalid = isEmpty(_AccParem.strChequeDate);
          break;
        case "txtBankName":
          // FIX: the case label had a trailing space ("txtBankName "), so
          // this check never ran
          isInvalid = isEmpty(_AccParem.strBankName);
          break;
        case "txtAccHolderName":
          isInvalid = isEmpty(_AccParem.strAccHolderName);
          break;
        default:
          break;
      }
      if (isInvalid) {
        Show_Message(dispatch, ValidateItem[i].strErrorMsg, "error");
        return false;
      }
    }
    return true;
  };
  return (
    <>
      <SideMenu ScrId={42} />
      <div className="Master-container">
        <MasterList
          ScrId={42}
          strSearchtxt={strSearch}
          tabOrder={_TabParem.PaymentSearchTab}
          Search={(val) => Search_Receipt(val)}
          arrMasterData={_HTParem.arrPayment}
          isImg={false}
          displayName="strRecNo"
          Parem1="iRecId"
          View_Data={(iRecId) => View_Receipt(iRecId)}
          placeholder="Receipt"
        />
        <div className="Master-card">
          <div className="Master-wrapper">
            <PayRecBody
              iScrId={42}
              RefreshNoFormat={() => Load_Receipt({ keepForm: true })}
              PartyUrl="Receipt/View_Party/"
              ViewAllBankUrl="Receipt/View_AllBank/"
              ViewPartyBankUrl="Receipt/View_PartyBank/"
            />
            <Messagedialogbox />
          </div>
          <AccountsButton
            iVouchId={_AccParem.iPayRecId}
            iScrId={42}
            Save={(e) => {
              if (!PropertiesValidation()) return;
              if (!(_HTParem.arrNoFormat || []).length) {
                Show_Message(
                  dispatch,
                  "Voucher number format is not configured",
                  "error"
                );
              } else if (_AccParem.isCancelStatus) {
                Show_Message(
                  dispatch,
                  "Cancelled Receipt cannot be modified",
                  "info"
                );
              } else if (
                Number(_AccParem.iVenTypeId) !== 6 &&
                Number(_AccParem.iVenId) === 0
              ) {
                Show_Message(dispatch, "Please Select Vendor", "info");
              } else if (!_AccParem.strVouchDate) {
                Show_Message(dispatch, "Please Select Receipt Date", "info");
              } else if (
                Number(_AccParem.iPayModeId) !== 1 &&
                !Number(_AccParem.iBankAccId)
              ) {
                Show_Message(dispatch, "Please Select Bank Account", "info");
              } else if (
                Number(_AccParem.iPayModeId) === 2 &&
                String(_AccParem.strChequeNo || "").trim() === ""
              ) {
                Show_Message(dispatch, "Cheque/DD Number is Invalid", "info");
              } else if (!(Number(_AccParem.dAmount) > 0)) {
                Show_Message(dispatch, "Please Enter Valid Amount", "info");
              } else {
                Ask_Question(
                  dispatch,
                  Save_Receipt,
                  "Do You Want to  Save Receipt?"
                );
              }
            }}
            Clear={ClearClick}
            Cancel={(e) => {
              if (Number(_AccParem.iPayRecId) === 0) {
                Show_Message(dispatch, "Please Select Receipt", "info");
              } else if (_AccParem.isCancelStatus) {
                Show_Message(dispatch, "Receipt is already Cancelled", "info");
              } else {
                Ask_Question(
                  dispatch,
                  Cancel_Receipt,
                  "Do You Want to  Cancel Receipt?"
                );
              }
            }}
          />
        </div>
      </div>
    </>
  );
}
export default Receipt;